<template>
  <div class="personals-top-bar">
    <nav class="flex flex-wrap items-center gap-3 font-label text-label-md text-on-surface-variant">
      <button class="hover:text-primary" type="button" @click="goPersonals">
        {{ t('personals.title') }}
      </button>
      <span class="opacity-30">/</span>
      <button class="hover:text-primary" type="button" @click="goMyPersonals">
        {{ t('personals.viewMyAds') }}
      </button>
      <span class="opacity-30">/</span>
      <button class="hover:text-primary" type="button" @click="goMyReplies">
        {{ t('personals.myReplies') }}
      </button>
      <span v-if="showCreateCTA" class="opacity-30">/</span>
      <button
        v-if="showCreateCTA"
        type="button"
        class="rounded-full bg-primary px-3 py-1 text-on-primary hover:bg-primary-container"
        @click="createAd"
      >
        {{ t('personals.createAd') }}
      </button>

      <!-- Optional right-side actions slot -->
      <slot name="rightActions" />
    </nav>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  showCreateCTA: {
    type: Boolean,
    default: true
  }
})

const router = useRouter()
const { t } = useI18n()
function goPersonals() {
  router.push({ name: 'personals' })
}
function goMyPersonals() {
  router.push({ name: 'my-personals' })
}
function goMyReplies() {
  router.push({ name: 'my-replies' })
}
function createAd() {
  // If a page wants to override this, they can intercept click from slot
  router.push({ name: 'create-personal' })
}
</script>

<style scoped>
.personals-top-bar {
  margin-bottom: 0.5rem; /* matches "mb-2" spacing used elsewhere */
}
</style>
